/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RepresentativeSelection} from "./representativeSelection.zod";

export const ChangeExpedientRepresentativeBody = zod.object({
  representative: zod.union([RepresentativeSelection, zod.null()]),
});

export type ChangeExpedientRepresentativeBody = zod.input<typeof ChangeExpedientRepresentativeBody>;
export type ChangeExpedientRepresentativeBodyOutput = zod.output<
  typeof ChangeExpedientRepresentativeBody
>;
